import { rootActions, useAppDispatch, useAppSelector } from '../DAL/store';
import {closeEfsPopup, translateReply} from "../services/logic-helper";
import {Popup} from "../../../ui/popup/popup";
import { useEffect, useRef, useState } from "react";
import Preloader from "../../../ui/svg/common/preloader";
import {checkIfPluginIsForFree} from "../DAL/data-service";

/*
*  renders popup according to the reply by either the user or server
* */
export const EfsPopup = () => {

    const [isLoading,setIsLoading] = useState(false);
    const PageData = useAppSelector(store => store.PageData);
    const reply = useAppSelector(store => store.reply);
    const selectedItemDescription = useAppSelector(store => store.selectedItemDescription);
    const itemCode = useAppSelector(store => store.itemCode);

    const yesButtonRef = useRef<HTMLButtonElement>(null);

    useEffect(() => {
        if(!yesButtonRef || !yesButtonRef.current) return;
        yesButtonRef.current.focus();
    }, []);

    const dispatch = useAppDispatch();
    /**
     /Function sends parameters to server to check if user is eligible for the selected plugin
     */
    const checkForFreePlugin = async () => {
        if(itemCode && PageData.campaignDetails.campaignID){

            setIsLoading(true);
            const response = await checkIfPluginIsForFree(PageData.campaignDetails.campaignID, itemCode);

            if(response && response.statusCode === 401){
                //user is not log in --> show login popup
                dispatch(
                    rootActions.main({
                        isLoggedInForFreePlugin:true,
                        showEfsPopup: false,
                        showLoginPage:true
                    })
                );
            }
            else if(!response || response.statusCode !== 200 || !response.data || !response.data.relatedData) return;

            const _replayByCode = translateReply(response.data.relatedData.successCode);
            if(_replayByCode === 'ERROR_CODE_SUCCESS'){
                //when register is successful, refetch the plugin list.
                dispatch(
                    rootActions.main({
                        reply: _replayByCode,
                        isPageLoad:true
                    })
                );
            }else{

                dispatch(
                    rootActions.main({
                        reply: _replayByCode
                    })
                );
            }
            setIsLoading(false);
        }

    }

    const GetPopupContent = () => {
        let popupRender;

        switch (reply) {
            case 'Confirm':
                popupRender = (
                    <div className="text-center p-4">
                        <div className="font-bold text-xl pb-4">Please Notice</div>
                        <p className="pb-4">Are you sure you want to get <b>{selectedItemDescription}</b> as your free plugin?</p>
                        <div className="w-full text-right flex items-center justify-center text-center pt-3">

                            <button className="w-btn w-auto px-8 md:px-16 mr-6 cursor-pointer"
                                   ref={ yesButtonRef }
                                   type="button"
                                   title="Yes"
                                   onClick={ checkForFreePlugin }>Yes</button>

                            <button className="w-btn-outline-black cursor-pointer"
                                   type="button"
                                   title="No"
                                   onClick={ () => closeEfsPopup(dispatch) }>No</button>
                        </div>

                    </div>
                )
                break;
            case 'ERROR_CODE_SUCCESS':
                popupRender = (
                    <div className="text-center p-4">
                        <div className="font-bold text-xl pb-4">Success!</div>
                        <p className="">We have registered <b>{selectedItemDescription}</b> to your Waves account.</p>
                        <a href="/support/activate" className="">See how to install &amp; activate your plugin</a>.
                    </div>
                )
                break;
            case 'ERROR_CODE_FAILED_SERIAL_REGISTRATION':
                popupRender = (
                    <div className="text-center p-4">
                        <div className="font-bold text-xl pb-4">Error</div>
                        <p className="">The plugin you selected cannot be registered.</p>
                    </div>
                )
                break;
            case 'ERROR_CODE_ERROR':
                popupRender = (
                    <div className="text-center p-4">
                        <div className="font-bold text-xl pb-4">Error</div>
                        <p className="">An error has occurred.</p>
                        <a href="/new-year-2021-choose-your-free-plugin" className="">Please make your selection again</a>.
                    </div>
                )
                break;
            /* case 'ERROR_CODE_NOT_ACTIVE':
                 popupRender = (
                     <div className="popup-in-box">
                         <div className="efs-popup-title">Please Notice</div>
                         <p className="efs-popup-desc">Are you sure you want to redeem free plugin for this item?</p>
                     </div>
                 )
                 break;*/
            case 'ERROR_CODE_ALREADY_RECEIVED':
                popupRender = (
                    <div className="text-center p-4">
                        <div className="font-bold text-xl pb-4">Plugin Already Received</div>
                        <p className="">You have already received your free plugin. We registered it to your Waves account.</p>
                        <a href="/support/activate" className="">See how to install &amp; activate your plugin</a>.
                    </div>
                )
                break;
            case 'ERROR_CODE_NOT_ELIGIBLE':
                /*const url = document.getElementById('efs-data').getAttribute('data-termsurl');*/
                popupRender = (
                    <div className="text-center p-4">
                        <div className="font-bold text-xl pb-4">Not Eligible</div>
                        <p className="">You are not eligible for a free plugin.</p>
                        <a href={PageData.campaignDetails.tcurl} className="">See terms and conditions</a>
                    </div>
                )
                break;
            /*case 'ERROR_CODE_FAILED_PRODUCING_ZPS':
                popupRender = (
                    <div className="popup-in-box">
                        <div className="efs-popup-title">Please Notice</div>
                        <p className="efs-popup-desc">Are you sure you want to redeem free plugin for this item?</p>
                    </div>
                )
                break;*/

            /*case 'ERROR_ITEM_CODE_NOT_ACTIVE':
                popupRender = (
                    <div className="popup-in-box">
                        <div className="efs-popup-title">Please Notice</div>
                        <p className="efs-popup-desc">Are you sure you want to redeem free plugin for this item?</p>
                    </div>
                )
                break;
            case 'ERROR_MAX_PRICE_OVER':
                popupRender = (
                    <div className="popup-in-box">
                        <div className="efs-popup-title">Please Notice</div>
                        <p className="efs-popup-desc">Are you sure you want to redeem free plugin for this item?</p>
                    </div>
                )
                break;*/
            default:
                popupRender = (
                    <div className="text-center p-4">
                        <div className="font-bold text-xl pb-4">Error</div>
                        <p className="waves-p">An error has occurred. Please
                            <a href={PageData.campaignDetails.freePluginURL} className=""> make your selection again</a>.
                        </p>
                    </div>
                )
                break;
        }
        return popupRender;
    }

    return (
        <Popup width="400px" height="230px" close={ () => closeEfsPopup(dispatch)}>
            <div className="w-full h-full flex items-center justify-center">
                {
                    isLoading ?
                    <Preloader width={"20px"} />
                    :
                    <>{GetPopupContent()}</>
                }
            </div>
        </Popup>
    )
};